// This file can be replaced during build by using the `fileReplacements` array.
// When building for development environment, this file is replaced with `environment.dev.ts`.
export const environment = {
    production: true,
    // apiUrl: 'https://api.dimamotion-dev.de',
    apiUrl: 'https://api-dima-motion.uat.link',
    env: 'development',
};
